import React from 'react'
import Collapsible from '../Collapsible/Collapsible'
import { useCollapsible } from 'client/fragments/listerFragment/components/Filters/Collapsible/useCollapsible'
import { AnimatePresence } from 'framer-motion'
import { ListFilterItems } from './ListFilterItems'
import { getId } from 'client/fragments/listerFragment/components/Filters/utilsFilters'

export const ListFilter = ({ filter, preventClick, onChange, buttonActiveText, buttonInactiveText, dataValue }) => {
  const { isCollapsed, setIsCollapsed } = useCollapsible()
  const accessibilityId = getId(`clps_${filter.name}`)

  return (
    <Collapsible isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} dataTestId='list' dataValue={filter.name}>
      <Collapsible.Header htmlFor={accessibilityId}>{filter.title}</Collapsible.Header>
      <AnimatePresence initial={false}>
        {!isCollapsed && (
          <Collapsible.Body>
            <ListFilterItems
              id={accessibilityId}
              filter={filter}
              preventClick={preventClick}
              onChange={onChange}
              buttonActiveText={buttonActiveText}
              buttonInactiveText={buttonInactiveText}
              className='mxd-mcollapse-body mxd-mcollapse-list'
              filterPosition='side'
            />
          </Collapsible.Body>
        )}
      </AnimatePresence>
    </Collapsible>
  )
}
